import type { ResetPasswordFormSchema } from "@/validation-schemas/reset-password-schemas";
import { AUTH_MESSAGES } from "@/rtkQuery/config/authApi.config";
import { useAuthService } from "./useAuthService";

export const useResetPasswordFormSubmission = () => {
    const {
        resetPassword,
        resetIsLoading: isLoading,
        resetIsSuccess: isSuccess,
        resetIsError: isError,
        resetStatus: status,
        resetPasswordResponse: data,
        resetPasswordError: error,
    } = useAuthService();

    const submitResetPasswordForm = async (formData: ResetPasswordFormSchema) => {
        try {
            const result = await resetPassword(formData, {
                success: AUTH_MESSAGES.RESET_SUCCESS,
            });

            if (result?.success) {
                return result;
            } else {
                console.error(result?.error);
            }
        } catch (err: any) {
            console.error("Reset Password Submission Failed", err);
        }
    };

    return {
        submitResetPasswordForm,
        isLoading,
        isSuccess,
        isError,
        status,
        data,
        error,
    };
};
